/*
 * Contrato do módulo Organograma da API (acampa-api-lumen,
 * OrganogramaController): o perfil do usuário logado e o que ele acessa.
 *
 * Consultor é quem tem nível 2 e e-mail `@atrialub.com.br`; diretor e gestor
 * saem de vínculos por `codUsuario` (mockados por enquanto, até a regra de
 * acesso definitiva).
 */

/** O prefixo `/api` já faz parte do baseURL do ApiService. */
export const ROTAS_API_ORGANOGRAMA = {
  acesso: "/organograma/acesso"
} as const;

export type PerfilOrganograma = "diretor" | "gestor" | "consultor";

/** Níveis do organograma, de cima para baixo. No Painel do Consultor, as telas. */
export type NivelOrganograma = "diretoria" | "regional" | "consultor";

/**
 * GET /organograma/acesso — aberta a qualquer usuário logado. Sem perfil,
 * `perfil` nulo e nenhuma tela.
 */
export interface AcessoOrganograma {
  perfil: PerfilOrganograma | null;
  /** Níveis que o perfil abre: o dele e os de baixo. */
  telas: NivelOrganograma[];
}
